import styled from "@emotion/styled";
import { Card, Col, Tag } from "antd";

export const FieldLabel = styled(Col)`
  font-weight: ${(props) => props.theme.fontWeight.bold};
  white-space: normal;
`;

export const FieldValue = styled(Col)`
  text-align: right;
`;

export const CardHeaderDescription = styled.span`
  word-wrap: break-word;
  white-space: normal;
`;

export const ProposalCard = styled(Card)`
  color: ${(props) => props.theme.color.primary};
  border-color: #a9a9a9;

  &:hover {
    border-color: #a9a9a9;
  }
`;

export const AddProposalButton = styled(ProposalCard)`
  width: 100%;
  height: 405px;
  text-align: center;
  line-height: 350px;

  &:hover {
    color: ${(props) => props.theme.color.complementary};
    transition: all 0.3s;
  }
`;

export const SettingContainer = styled(Col)`
  width: 30px;
  text-align: center;
  border-radius: 4px;

  &:hover {
    background-color: #e8e82f;
    transition: all 0.3s;
    cursor: pointer;
  }
`;

export const ViewMoreBar = styled.div`
  background: ${(props) => props.theme.color.complementary};
  text-align: center;
  padding: 12px;

  &:hover {
    font-weight: bold;
    transition: all 0.3s;
    cursor: pointer;
  }
`;

export const ProposalCardBody = styled.div`
  padding: 16px;
  min-height: 298px;
`;

export const KeyFieldValue = styled.span`
  width: 100%;
  background: ${(props) => props.backgroundColor};
  border: 1px solid black;
  padding: 5px;
  font-weight: bold;
`;

export const CardTag = styled(Tag)`
  border-radius: 0 0 4px;
  border-width: 0 1px 1px 0;
  position: absolute;
  top: 0;
  left: 0;
`;

export const CardTitle = styled.div`
  text-align: center;
`;
